const calculateTimeBetweenDates = (dateFrom: string, dateTo: string) => {
  const rangeInSeconds =
    (new Date(dateTo).getTime() - new Date(dateFrom).getTime()) / 1000;
  const secondsInDay = 24 * 3600;

  return rangeInSeconds + secondsInDay;
};

export default calculateTimeBetweenDates;
